import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["customSagas"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga);

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { fork } from 'redux-saga/effects';
import viewModelSaga from './view-model/view-models-saga';
import readModelSaga from './read-model/read-models-saga';
import commandSaga from './command/command-saga';

function rootSaga(_ref) {
  var customSagas, sagaArgs, _iterator, _step, customSaga;

  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          customSagas = _ref.customSagas, sagaArgs = _objectWithoutPropertiesLoose(_ref, _excluded);
          _context.next = 3;
          return fork(viewModelSaga, sagaArgs);

        case 3:
          _context.next = 5;
          return fork(commandSaga, sagaArgs);

        case 5:
          _context.next = 7;
          return fork(readModelSaga, sagaArgs);

        case 7:
          _iterator = _createForOfIteratorHelperLoose(customSagas);

        case 8:
          if ((_step = _iterator()).done) {
            _context.next = 14;
            break;
          }

          customSaga = _step.value;
          _context.next = 12;
          return fork(customSaga, sagaArgs);

        case 12:
          _context.next = 8;
          break;

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

export default rootSaga;
//# sourceMappingURL=root-saga.js.map